export enum AjaxResult {
  Success,
  Failure,
  Unauthorized,
  Forbidden,
  Cancelled,
  BadRequest
}
